import { BusinessLocationData } from "../../interfaces/BusinessObject";

export function getBusinessLocation(value: unknown): BusinessLocationData {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const location = value as Record<string, unknown>;
  return {
    mapsUrl: typeof location.mapsUrl === "string" ? location.mapsUrl : undefined,
    placeId: getGooglePlaceId(location.placeId) ?? undefined,
  };
}

export function getGooglePlaceId(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const id = value.trim();
  return /^[A-Za-z0-9_-]{1,512}$/.test(id) ? id : null;
}

/** Accept links to Maps only; arbitrary business attributes must not become executable URLs. */
export function getGoogleMapsUrl(value: unknown): string | null {
  if (typeof value !== "string" || value.length > 4096) return null;
  try {
    const url = new URL(value.trim());
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password || url.port) return null;
    const host = url.hostname.toLowerCase();
    const path = url.pathname;
    const isMapsPath = path === "/maps" || path.startsWith("/maps/");
    const isGoogleMaps = ["google.com", "www.google.com", "google.co.in", "www.google.co.in"].includes(host) && isMapsPath;
    const isMapsHost = ["maps.google.com", "maps.google.co.in", "maps.app.goo.gl", "g.page"].includes(host);
    const isLegacyShare = host === "goo.gl" && isMapsPath;
    if (!isGoogleMaps && !isMapsHost && !isLegacyShare) return null;
    url.protocol = "https:";
    return url.href;
  } catch {
    return null;
  }
}

/** Generated from the persisted ID, without storing Google-supplied names or addresses. */
export function buildGooglePlaceUrl(placeId: string): string | null {
  const id = getGooglePlaceId(placeId);
  if (!id) return null;
  return `https://www.google.com/maps/search/?api=1&query=Google%20Maps&query_place_id=${encodeURIComponent(id)}`;
}
